import { AxiosService } from './axios.service'
import FileSaver from 'file-saver'

/**
 * Defines the API methods for the client ticket
 */
export class ClientTicketService {
	static baseURL = 'cliente/bilhete'

	/**
	 * Get client tickets
	 */
	static getTickets(orderNumber) {
		return AxiosService.get(this.baseURL, {
			params: { orderNumber },
		}).then(({ data }) => data.data)
	}

	/**
	 * Return a ticket
	 */
	static returnTicket({ ticketId, cancelAll, isGoing }) {
		return AxiosService.post(`${this.baseURL}/devolver`, {
			ticketId,
			cancelAll,
			isGoing,
		}).then(({ data }) => data)
	}

	/**
	 * Resend trip data to user e-mail
	 * @param {number} orderNumber
	 */
	static resendTripData(orderNumber) {
		return AxiosService.post(`${this.baseURL}/reenviar-por-email`, {
			orderNumber,
		}).then(({ data }) => data)
	}

	/**
	 * download BPE files
	 */
	static async download(orderNumber, trackNumber, userId, type) {
		let params = {
			orderNumber: orderNumber,
			trackNumber: trackNumber,
			buyerId: userId,
			type: type,
		}
		return AxiosService.get(`${this.baseURL}/download`, {
			params: params,
			responseType: 'blob',
		})
	}

	static async generateBpeFiles(orderNumber, userId) {
		let params = {
			orderNumber: orderNumber,
			buyerId: userId,
		}
		AxiosService.post(`${this.baseURL}/gerar-arquivos`, params).then(
			({ data }) => data
		)
	}
}
